import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
} from "react";

import { useRouter } from "next/router";
import propTypes from "prop-types";

const GetPreviousUrlProviderContext = createContext(null);

const PreviousUrlUpdater = ({ previousUrlRef, currentUrlRef }) => {
  const router = useRouter();

  useEffect(() => {
    // This first check only runs on the first mount
    if (!currentUrlRef.current) {
      currentUrlRef.current = router.asPath;
      previousUrlRef.current = document.referrer;
    } else if (currentUrlRef.current) {
      previousUrlRef.current = currentUrlRef.current;
      currentUrlRef.current = router.asPath;
    }
  }, [router.pathname]);

  return null;
};

PreviousUrlUpdater.propTypes = {
  previousUrlRef: propTypes.shape({ current: propTypes.string }),
  currentUrlRef: propTypes.shape({ current: propTypes.string }),
};

export const GetPreviousUrlProvider = ({ children }) => {
  const previousUrlRef = useRef("");
  const currentUrlRef = useRef("");

  const getPreviousUrl = useCallback(() => {
    return previousUrlRef.current;
  }, []);

  return (
    <>
      <GetPreviousUrlProviderContext.Provider value={getPreviousUrl}>
        <PreviousUrlUpdater
          previousUrlRef={previousUrlRef}
          currentUrlRef={currentUrlRef}
        />
        {children}
      </GetPreviousUrlProviderContext.Provider>
    </>
  );
};

const useGetPreviousUrl = () => {
  const getPreviousUrl = useContext(GetPreviousUrlProviderContext);

  if (!getPreviousUrl) {
    throw Error(
      "Cannot call `useGetPreviousUrl` outside of the react context of `GetPreviousUrlProvider`",
    );
  }
  return getPreviousUrl;
};

export default useGetPreviousUrl;

GetPreviousUrlProvider.propTypes = {
  children: propTypes.node,
};
